import '../../styles/web-components/add-to-cart-overlay.scss';
import { showInlineCart } from '../helpers/utils';
import { createCartLineItem, fetchAdditionalProductVariantInfo } from '../helpers/cart.helper';
class AddToCartOverlay extends HTMLElement {
    static get observedAttributes() {
        return ["cart-line-item-data", "recommendation-parameters"];
    }
    async renderCartLineItemData(value) {
        const cartLineItemData = JSON.parse(value);
        const additionalData = await fetchAdditionalProductVariantInfo([cartLineItemData.variant_id], { badgePrefix: "badge-cart:" });
        const extraData = additionalData[cartLineItemData.variant_id];
        const cartLineItemDataExtended = extraData ? { ...cartLineItemData, ...extraData } : cartLineItemData;
        const cartLineItemEl = createCartLineItem(cartLineItemDataExtended, { showQuantity: false, actionsType: 'add-to-cart-overlay', styleClass: 'atc-overlay__cart-line-item' });
        const skeleton = this.querySelector(".atc-overlay__cart-line-item-skeleton");
        skeleton.replaceWith(cartLineItemEl);
    }
    constructor() {
        super();
        this.addEventListener("click", (e) => {
            const target = e.target;
            // TODO: if this variation wins, this should be refactored
            if (target.classList.contains("view-cart") && window.ABTestATCOverlayViewCart) {
                e.preventDefault();
                showInlineCart();
                this.closest(".main-dialog").querySelector(".main-dialog__close-button").click();
            }
        });
    }
    async attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue === newValue)
            return;
        switch (name) {
            case "cart-line-item-data": {
                this.render();
                const checkoutCtaTemplate = document.getElementById("utk-checkout-cta-template");
                if (!checkoutCtaTemplate) {
                    console.error("No existing checkout button template found; cannot render");
                    return;
                }
                this.querySelector("form").append(checkoutCtaTemplate.content.firstElementChild.cloneNode(true));
                await this.renderCartLineItemData(newValue);
                break;
            }
            case "recommendation-parameters": {
                const recommendationParameters = JSON.parse(newValue);
                const recommendationEl = document.createElement("recommendations-carousel");
                recommendationEl.classList.add('atc-overlay__recommendations');
                Object.entries(recommendationParameters).forEach(entry => {
                    const [key, val] = entry;
                    recommendationEl.setAttribute(key, val);
                });
                this.querySelector(".atc-overlay__additional-content").append(recommendationEl);
                break;
            }
            default:
                break;
        }
    }
    render() {
        this.innerHTML = `
      <div>
        <h2 class="atc-overlay__header">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <g clip-path="url(#clip0_405_3941)">
              <path d="M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM9.6 18L3.6 12L5.292 10.308L9.6 14.604L18.708 5.496L20.4 7.2L9.6 18Z" fill="#24882D"/>
            </g>
            <defs>
              <clipPath id="clip0_405_3941">
                <rect width="24" height="24" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          Item Added to the Cart
        </h2>
        <div class="atc-overlay__content">
          <div class="atc-overlay__main-container">
            <div class="atc-overlay__cart-line-item-skeleton"></div>
            <div class="atc-overlay__action-container">
              <form action="/checkout" method="post"></form>
              <a href="/cart" class="button cart-ctas__view-cart view-cart">View Cart</a>
              <cart-progress></cart-progress>
            </div>
          </div>
          <div class="atc-overlay__additional-content"></div>
        </div>
      </div>`;
    }
}
if (!window.customElements.get("add-to-cart-overlay")) {
    customElements.define("add-to-cart-overlay", AddToCartOverlay);
}
